enum ParkingSlotType {
    Warming = 1,
    Charging = 2,
    WarmSpot = 3,
}

export default ParkingSlotType;
